import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { IBAN_COMPONENT_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds.ts';
import { Anchor, Flex, Paper, Text } from '@mantine/core';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import type { BankAccountCountryOption } from '../types.ts';

interface Props {
	option: BankAccountCountryOption | undefined;
	showDetectedCaption: boolean;
	disabled: boolean;
	onChange: () => void;
}

export const BankCountrySummary = ({ option, showDetectedCaption, disabled, onChange }: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<Paper
			withBorder
			p="sm"
			bg="gray.0"
			data-testid={IBAN_COMPONENT_ELEMENT_ID.BANK_COUNTRY_SUMMARY}
		>
			<Flex justify="space-between" align="center" gap="0.5rem">
				<Flex direction="column" gap="0.125rem">
					<Flex align="center" gap="0.5rem">
						<Text size="md" fw={600}>
							{option?.label ?? tCapManage('bank_account.drawer.country.placeholder')}
						</Text>
						{option && <ReactCountryFlag countryCode={option.value} svg />}
					</Flex>
					{showDetectedCaption && (
						<Text size="sm" c="gray.9">
							{tCapManage('bank_account.drawer.country_detected_caption')}
						</Text>
					)}
				</Flex>
				{!disabled && (
					<Anchor
						component="button"
						type="button"
						size="sm"
						fw={600}
						onClick={onChange}
						data-testid={IBAN_COMPONENT_ELEMENT_ID.BANK_COUNTRY_CHANGE_BUTTON}
					>
						{tCapManage('bank_account.drawer.country_change_button')}
					</Anchor>
				)}
			</Flex>
		</Paper>
	);
};
